import type Email from "@/domain/entities/emails/Email";
import {
    assistantMails,
    type AssistantMailsCache,
} from "@/hooks/mails/assistantMailsCache";
import { isSameCopy } from "@/lib/mailIdentity";
import { queryKeys } from "@/lib/queryKeys";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

/**
 * A mail opened from the chat, read live from the list it was shown in (`listId`), so an action done
 * meanwhile shows; no longer in the list, the mail as it was opened.
 */
const useLiveAssistantMail = (listId: string, mail: Email | undefined) => {
    const { data: listCache } = useQuery<AssistantMailsCache>({
        queryKey: queryKeys.mails.list(listId),
        enabled: false,
    });

    return useMemo(
        () =>
            mail &&
            (assistantMails(listCache).find((item) => isSameCopy(item, mail)) ??
                mail),
        [listCache, mail],
    );
};

export default useLiveAssistantMail;
